/**
 * The sidebar's "waiting on us" badges (owner, 2026-11-05): one GET that answers every area's
 * count at once (`apps/api/src/admin-nav-counts`), read fresh every time. No query keys: the
 * counts are global, never filtered by the caller.
 * Split out of `catalog.ts` on file-size grounds only.
 *
 * The path has no `:param`, so nothing can ride it as an id and `upstream-siblings.ts` needs no row.
 */
import type { ReadRoute } from "./catalog";

export const NAV_COUNTS_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/nav-counts", query: [] },
];
